import React from 'react';
import { useTranslations } from 'next-intl';

import { StyledMapSkeleton } from './map.style';

const MapSkeleton = () => {
  const t = useTranslations();
  return <StyledMapSkeleton>{t('map.loading')}</StyledMapSkeleton>;
};

export default MapSkeleton;
